import { useState } from 'react';
import { CasBaseDialog, CasTable } from 'src/compass/shared/components';
import CasLink from 'src/compass/shared/components/CasLink/CasLink';
import ICasRenderCellProps from 'src/compass/shared/components/CasTable/ICasRenderCellProps';

import { ClaimColumns } from '../ClaimListing/ClaimListing';
// Cycle by design: a claim in this grid opens its own details, which can open this dialog again.
import ClaimDetailsDialog from './ClaimDetailsDialog';

interface SharedClaimNumberDialogProps {
  claimNumber: number;
  onClose: VoidFunction;
}

export default function SharedClaimNumberDialog({
  claimNumber,
  onClose,
}: SharedClaimNumberDialogProps) {
  const [detailsId, setDetailsId] = useState<number | null>(null);

  return (
    <CasBaseDialog open maxWidth="md" onClose={onClose} title={`Claim# ${claimNumber}`} showCloseIcon>
      <CasTable
        entity="Sce/Claims"
        additionalPayload={{ claimNumber }}
        defaultOrderBy="sce"
        includeExport={false}
        showPagination={false}
        columns={[
          ClaimColumns.reinsuranceYear,
          ClaimColumns.policyNumber,
          {
            ...ClaimColumns.sce,
            render: ({ row }: ICasRenderCellProps) => (
              <CasLink onClick={() => setDetailsId(row.id)}>{row.sce}</CasLink>
            ),
          },
          ClaimColumns.status,
          ClaimColumns.effectiveDate,
          ClaimColumns.endDate,
        ]}
      />

      {detailsId && (
        <ClaimDetailsDialog id={detailsId} onClose={() => setDetailsId(null)} />
      )}
    </CasBaseDialog>
  );
}
